import React, { useState } from 'react'
import CenterModal from '../../../components/Modals/center-modal';
import { ReactComponent as CloseIcon } from '../../../assets/close.svg';
import { ReactComponent as Phone3DIcon } from '../../../assets/icons/3d-phone.svg'
import { ReactComponent as CallIcon } from '../../../assets/icons/call.svg';
import { ReactComponent as CallRingIcon } from '../../../assets/icons/Phone_call_ring.svg'
import { inviteUser } from '../../../services/public/public.service';
import MobileInput from '../../../components/InputGroup/MobileInput';
import InputText from '../../../components/InputGroup/InputText';
import { ReactComponent as SuccessIcon } from '../../../assets/sucessful.svg'

const OwnerSignupAndInvite = ({ show, closeModal }) => {
    const [stage, setStage] = useState(1);
    const [name, setName] = useState('');
    const [mobile, setMobile] = useState('');
    const [error, setError] = useState(false);

    const handleSubmit = async () => {
        if (!name || !mobile) {
            setError(true);
            return;
        } else {
            setError(false);
        }
        const payload = {
            users: [
                {
                    mobile: mobile,
                    userName: name
                }
            ]
        }
        const res = await inviteUser(payload);
        if (res.data.status) {
            setStage(2)
        }
    }

    return (
        <CenterModal show={show} closeModal={closeModal} modalClass='!max-w-[560px]  [&>*]:!border-0 [&>*]:!rounded-lg [&>*]:!overflow-hidden' backDropClassName={''}>

            {stage === 1 && <div className=''>
                <div className='flex justify-between p-6 border-b'>
                    <p className='mb-0 text-xl font-semibold'>Invite user</p>
                    <button onClick={closeModal} className=''><CloseIcon /></button>
                </div>
                <div className='!w-[300px] mx-auto !my-12'>
                    <InputText
                        label='Name'
                        placeholder='Rahul'
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required={true}
                        error={(error && !name) ? 'Please enter name' : ''}
                    />
                    <MobileInput
                        label='Mobile'
                        value={mobile}
                        onChange={(e) => setMobile(e.phone)}
                        error={(error && !mobile) ? 'Please enter mobile' : ''}
                        inputclass='!h-10'
                    />
                    <button className='border rounded-lg gradient-blue text-white font-semibold text-center w-full !py-3 !mt-8' onClick={handleSubmit}>Submit</button>
                    <button className='border rounded-lg inner-btn-shadow text-center w-full !py-3 !mt-4' onClick={closeModal}>Cancel</button>
                </div>
            </div>}
            {stage === 2 && <div className='!w-[327px] mx-auto !my-12'>
                <div className='flex flex-col items-center justify-center'>
                    <SuccessIcon />
                    <h3 className='text-xl font-semibold !mt-6'>
                        Invite Sent
                    </h3>
                    <p className='mb-0 mt-2.5 text-[#667085] text-center'>Invite has been sent to <span className='font-semibold'>{name}</span> at
                        <span className='font-semibold'>{` ${mobile}`}</span> number, they can login with Company Code. </p>

                    <button className='border rounded-lg gradient-blue text-white font-semibold text-center w-full !py-3 !mt-8' onClick={() => {
                        setName('')
                        setMobile('')
                        setStage(1)
                    }}>Invite More Member</button>
                    <button className='border rounded-lg inner-btn-shadow text-center w-full !py-3 !mt-4' onClick={closeModal}>Done</button>
                </div>
            </div>}

        </CenterModal>
    )
}

export default OwnerSignupAndInvite;